import { render, staticRenderFns } from "./ActionDetail.vue?vue&type=template&id=89d5bee6&scoped=true&"
import script from "./ActionDetail.vue?vue&type=script&lang=js&"
export * from "./ActionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActionDetail.vue?vue&type=style&index=0&id=89d5bee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d5bee6",
  null
  
)

export default component.exports